import { useEffect, useState } from 'react';

export const usePageVisibilityState = () => {
  const [isVisible, setIsVisible] = useState(
    document.visibilityState === 'visible'
  );

  useEffect(() => {
    const onHandleVisibilityChange = () => {
      const nextIsVisible = document.visibilityState === 'visible';

      setIsVisible((previousIsVisible) =>
        previousIsVisible === nextIsVisible ? previousIsVisible : nextIsVisible
      );
    };

    document.addEventListener('visibilitychange', onHandleVisibilityChange);
    return () =>
      document.removeEventListener(
        'visibilitychange',
        onHandleVisibilityChange
      );
  }, []);

  return isVisible;
};
